import MultiLanguages from "@admin/components/MultiLanguage";
import Input from "@admin/components/Input";
import TextArea from "@admin/components/TextArea";
import React, { useState } from "react";
import { AboutPageGeneralDirectorBannerModel, AboutPageModel } from "@admin/domain/uniquePages/models/AboutPageModel";
import { makePath } from "@admin/utils/makePath";
import { useLanguageContext } from "@admin/components/LanguagesContext";
import AboutPageGeneralDirectorModal from "./AboutPageGeneralDirectorModal";
import { v4 as uuid } from "uuid";
import { type UniquePageProps } from "../../index";
import Sortable from "@admin/components/Sortable";

export default function AboutPageGeneralDirector({ page }: UniquePageProps<AboutPageModel>) {
    const initBanners = (page.contentObject.general_director__banners || []).map((value) => {
        return { ...value, id: uuid() };
    });

    const languageContext = useLanguageContext();

    const [showModal, setShowModal] = useState(false);
    const [banners, setBanners] = useState(initBanners);
    const [editableBanner, setEditableBanner] = useState<AboutPageGeneralDirectorBannerModel | undefined>();

    const addHandle = (data: AboutPageGeneralDirectorBannerModel) => {
        setBanners((prev) => [...prev, data]);
    };

    const editHandle = (data: AboutPageGeneralDirectorBannerModel) => {
        setBanners((prev) =>
            prev.map((value) => {
                if (value.id === data.id) value = data;
                return value;
            }),
        );
    };

    return (
        <div className="mb-10">
            <h4 className="mb-5">Блоке с информацией о генеральном директоре</h4>
            <MultiLanguages
                languageElement={(language) => (
                    <div>
                        <Input
                            label="Заголовок"
                            name={`content[general_director__title][${language}]`}
                            defaultValue={page.contentObject.general_director__title[language]}
                        />
                        <Input
                            label="Подзаголовок"
                            name={`content[general_director__sub_title][${language}]`}
                            defaultValue={page.contentObject.general_director__sub_title[language]}
                        />
                        <TextArea
                            label="Текст"
                            name={`content[general_director__text][${language}]`}
                            defaultValue={page.contentObject.general_director__text[language]}
                        />
                    </div>
                )}
            />
            <Sortable list={banners} setList={setBanners} className="row row-cols-auto">
                {banners.map((banner, index) => (
                    <div key={banner.id} className="mb-5" style={{ width: `fit-content`, height: `fit-content` }}>
                        <div className="card border">
                            <img
                                style={{ width: `500px`, height: `500px` }}
                                className="card-img-top img_placeholder img-thumbnail"
                                src={makePath(banner.file?.path)}
                            />
                            <input
                                type="hidden"
                                name={`content[general_director__banners][${index}][file_id]`}
                                value={banner.file?.id}
                            />
                            <div className="card-body">
                                <div className="card-text mb-3">
                                    <div>
                                        <span className="fw-bolder">Текст:{` `}</span>
                                        {` `}
                                        {banner.text[languageContext.currentLanguage]}
                                        {Object.entries(languageContext.availableLanguages).map(([, lang]) => (
                                            <input
                                                type="hidden"
                                                key={lang}
                                                name={`content[general_director__banners][${index}][text][${lang}]`}
                                                value={banner.text[lang]}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div>
                                    <a
                                        className="card-link text-success"
                                        onClick={() => {
                                            setEditableBanner(banner);
                                            setShowModal(true);
                                        }}
                                    >
                                        Редактировать
                                    </a>
                                    <a
                                        className="card-link text-danger"
                                        onClick={() => {
                                            setBanners((prev) => prev.filter((value) => value.id !== banner.id));
                                        }}
                                    >
                                        Удалить
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Sortable>
            <i
                className="bi bi-plus-square text-primary fs-2hx cursor-pointer ms-3 align-self-center"
                onClick={() => {
                    setEditableBanner(undefined);
                    setShowModal(true);
                }}
            />
            {showModal && (
                <AboutPageGeneralDirectorModal
                    showModal={showModal}
                    closeModal={() => setShowModal(false)}
                    onSubmit={editableBanner ? editHandle : addHandle}
                    editableBanner={editableBanner}
                />
            )}
        </div>
    );
}
